import {globalWindow} from '../../libs/shared/helpers/src/browser/browserHelpers';

export function isOnline() {
  return globalWindow.navigator.onLine;
}
